import { defineComponent, ref, computed } from 'vue';
import __vue_component__ from '../../../alerts/Alert.vue.js';
import __vue_component__$1 from '../../../buttons/ButtonComponent/ButtonComponent.vue.js';
import { ButtonStyle } from '../../../buttons/ButtonComponent/model.js';
import { getDownloadOptions, downloadOrOpenFile } from '../../FileViewer/controller.js';
import __vue_component__$2 from '../../../specific/portal/components/ItineraryList/components/ExpandCopyID.vue.js';
import __vue_component__$3 from '../../../ui/ImageComponent.vue.js';
import __vue_component__$4 from '../../../ui/InteractivePopup/InteractivePopup.vue.js';
import __vue_component__$5 from '../../../ui/Loading/Loading.vue.js';
import '@caresend/types';
import 'file-saver';
import '../../../../database/firebaseConfig/cloudFunctions.js';
import { DownloadOption } from '../../../../database/encryption/model.js';
import '@caresend/utils';
import 'js-sha256';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../../ui/Icon.vue.js';
import '../../../../functions/configuration/icons.js';
import '../../../../database/algoliaConfig/indices.js';
import { preventParentClickAndDefault } from '../../../../functions/preventDefault.js';
import 'mobile-device-detect';
import '../../../../functions/tracking/index.js';

var script = defineComponent({
    name: 'UploadedFileCard',
    components: {
        Alert: __vue_component__,
        ButtonComponent: __vue_component__$1,
        ExpandCopyID: __vue_component__$2,
        ImageComponent: __vue_component__$3,
        InteractivePopup: __vue_component__$4,
        Loading: __vue_component__$5,
    },
    props: {
        confirmDelete: {
            type: Boolean,
            default: true,
        },
        customOptions: {
            type: Array,
            default: () => [],
        },
        desktopOptions: {
            type: Array,
            default: () => [DownloadOption.OPEN, DownloadOption.DOWNLOAD],
        },
        fileNameOverride: {
            type: String,
            default: undefined,
        },
        downloadLabel: {
            type: String,
            default: 'Download',
        },
        file: {
            type: Object,
            required: true,
        },
        isPDF: Boolean,
        /**
         * By default, we only show the `download` button on devices detected as
         * mobile based on user agent.
         */
        optionsStyle: {
            type: String,
            default: 'kebab',
        },
        mobileOptions: {
            type: Array,
            default: () => [DownloadOption.DOWNLOAD],
        },
        noDelete: Boolean,
        openLabel: {
            type: String,
            default: 'Open',
        },
        optionsHidden: Boolean,
    },
    setup(props, { emit }) {
        const isConfirmingDelete = ref(false);
        const showIconReplacement = ref(props.isPDF || !!props.file.encryptedFile);
        const setShowIconReplacement = (val) => {
            showIconReplacement.value = val;
        };
        const doConfirmDelete = () => {
            emit('delete');
            isConfirmingDelete.value = false;
        };
        const handleDelete = () => {
            if (props.confirmDelete)
                isConfirmingDelete.value = true;
            else
                emit('delete');
        };
        const downloadOptions = getDownloadOptions(props.desktopOptions, props.mobileOptions, props.openLabel, props.downloadLabel);
        const isLoading = ref(false);
        const setLoading = (val) => {
            isLoading.value = val;
        };
        const allOptions = computed(() => {
            var _a;
            const optionsWithActions = (_a = downloadOptions.value) === null || _a === void 0 ? void 0 : _a.map((option) => ({
                ...option,
                action: async () => {
                    setLoading(true);
                    try {
                        await downloadOrOpenFile(props.file, option.value);
                    }
                    finally {
                        setLoading(false);
                    }
                },
            }));
            if (!props.noDelete) {
                optionsWithActions.push({
                    label: 'Delete',
                    action: handleDelete,
                    icon: 'times',
                    buttonStyle: ButtonStyle.FROSTED,
                });
            }
            return [...optionsWithActions, ...props.customOptions];
        });
        const isOptionsPopoverOpened = ref(false);
        const performAction = (option) => {
            var _a;
            (_a = option.action) === null || _a === void 0 ? void 0 : _a.call(option);
            isOptionsPopoverOpened.value = false;
        };
        return {
            allOptions,
            doConfirmDelete,
            handleDelete,
            isConfirmingDelete,
            isLoading,
            performAction,
            preventParentClickAndDefault,
            setShowIconReplacement,
            showIconReplacement,
            isOptionsPopoverOpened,
        };
    },
});

export { script as default };
